import {Fragment, useContext, useEffect, useState} from "react";
import log from "loglevel";
import {ManifestDataContext, ManifestDataState} from "../../providers/ManifestDataProvider";
import {Job, useMap_SearchJobsQuery} from "../../../../generated/graphql";
import {useListActionBarDispatch} from "../../../common/ListActionBarProvider";
import {useAssignmentState} from "../../../../providers/AssignmentProdiver";

type AssignDriverContainerProps = {
  children: JSX.Element[] | JSX.Element;
};
const AssignDriverContainer = ({children}: AssignDriverContainerProps) => {
  const assignmentState = useAssignmentState();

  const manifestDataState = useContext<ManifestDataState>(ManifestDataContext);
  const [job, setJob] = useState<Job>();
  const [manifestJob, setManifestJob] = useState<Job>();
  const listActionBarDispatch = useListActionBarDispatch();

  const {data, error, loading} = useMap_SearchJobsQuery({
    variables: {
      filter: {
        job: {
          jobId: {
            eq: manifestJob?.jobId
          }
        }
      }
    },
    skip: !manifestJob?.jobId
  });

  useEffect(() => {
    if (assignmentState.selectedJobs.length > 0) {
      setManifestJob(assignmentState.selectedJobs[0]);
    }
  }, [assignmentState]);

  useEffect(() => {
    if (error) {
      log.error(error);
    }
    if (!loading && data?.searchJobs?.items) {
      setJob(data.searchJobs.items[0] as Job);
    }
  }, [data, error, loading]);

  useEffect(() => {
    if (job?.order.requirements && job?.order.requirements?.length > 0) {
      listActionBarDispatch({type: "SET_BUTTON_HIDDEN", payload: {id: "qualified-drivers", hidden: false}});
    } else {
      listActionBarDispatch({type: "SET_BUTTON_HIDDEN", payload: {id: "qualified-drivers", hidden: true}});
    }
  }, [job, listActionBarDispatch, manifestDataState.data]);

  return <Fragment>{children}</Fragment>;
};

export default AssignDriverContainer;
